import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import AgGridTable from "../../../../utilities/AgGridTable";
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.min.css';
// import customStyle from './SummaryGrid.css'
import oAuthServiceConfig from 'src/app/auth/services/oAuthService/oAuthServiceConfig';
import OAuthService from 'src/app/auth/services/oAuthService';
import data from "./territoryData";

const processData = (data) => {
    const flattenedData = [];
    const flattenRowRecursive = (row, parentPath) => {
        row['partnerName'] = "Universal Trading Company"
        row["january"] = 0;
        row["february"] = 0;
        row["march"] = 1;
        row["april"] = 0;
        row["may"] = 2;
        row["june"] = 0;
        row["july"] = 0;
        row["august"] = 1;
        row["september"] = 2;
        row["october"] = 0;
        row["november"] = 0;
        row["december"] = 0;
        row["totalDays"] = 6;
        const dataPath = [...parentPath, row.orderCategory];
        flattenedData.push({ ...row, dataPath });
        if (row.subCategories) {
            row.subCategories.forEach((underling) =>
                flattenRowRecursive(underling, dataPath)
            );
        }
    };
    data.forEach((row) => flattenRowRecursive(row, []));
    return flattenedData;
};

const TerritoryWiseGrid = (props) => {
    const [rowData, setRowData] = useState(data);
    const [columnDefs, setColumnDefs] = useState([
        { field: "partnerName", headerName: "PARTNER NAME", filter: false },
        { field: "january", headerName: "JAN", filter: false },
        { field: "february", headerName: "FEB", filter: false },
        { field: "march", headerName: "MAR", filter: false },
        { field: "april", headerName: "APR", filter: false },
        { field: "may", headerName: "MAY", filter: false },
        { field: "june", headerName: "JUN", filter: false },
        { field: "july", headerName: "JUL", filter: false },
        { field: "august", headerName: "AUG", filter: false },
        { field: "september", headerName: "SEP", filter: false },
        { field: "october", headerName: "OCT", filter: false },
        { field: "november", headerName: "NOV", filter: false },
        { field: "december", headerName: "DEC", filter: false },
        { field: "totalDays", headerName: "TOTAL DAYS", filter: false },
    ]);

    const [columnDefsMonthWise, setColumnDefsMonthWise] = useState([
        { field: "partnerName", headerName: "PARTNER NAME", width: 100, filter: false },
        { headerName: "JAN", children: [{ field: "planJan", headerName: "P", filter: false, width: 25, maxWidth: 30 }, { field: "actualsJan", headerName: "A", filter: false, width: 25, maxWidth: 30 }, { field: "daysJan", headerName: "D", filter: false, width: 25, maxWidth: 30 }] },
        { headerName: "FEB", children: [{ field: "planFeb", headerName: "P", filter: false, width: 25, maxWidth: 30 }, { field: "actualsFeb", headerName: "A", filter: false, width: 25, maxWidth: 30 }, { field: "daysFeb", headerName: "D", filter: false, width: 25, maxWidth: 30 }] },
        { headerName: "MAR", children: [{ field: "planMar", headerName: "P", filter: false, width: 25, maxWidth: 30 }, { field: "actualsMar", headerName: "A", filter: false, width: 25, maxWidth: 30 }, { field: "daysMar", headerName: "D", filter: false, width: 25, maxWidth: 30 }] },
        { headerName: "APR", children: [{ field: "planApr", headerName: "P", filter: false, width: 25, maxWidth: 30 }, { field: "actualsApr", headerName: "A", filter: false, width: 25, maxWidth: 30 }, { field: "daysApr", headerName: "D", filter: false, width: 25, maxWidth: 30 }] },
        { headerName: "MAY", children: [{ field: "planMay", headerName: "P", filter: false, width: 25, maxWidth: 30 }, { field: "actualsMay", headerName: "A", filter: false, width: 25, maxWidth: 30 }, { field: "daysMay", headerName: "D", filter: false, width: 25, maxWidth: 30 }] },
        { headerName: "JUN", children: [{ field: "planJun", headerName: "P", filter: false, width: 25, maxWidth: 30 }, { field: "actualsJun", headerName: "A", filter: false, width: 25, maxWidth: 30 }, { field: "daysJun", headerName: "D", filter: false, width: 25, maxWidth: 30 }] },
        { headerName: "JUL", children: [{ field: "planJul", headerName: "P", filter: false, width: 25, maxWidth: 30 }, { field: "actualsJul", headerName: "A", filter: false, width: 25, maxWidth: 30 }, { field: "daysJul", headerName: "D", filter: false, width: 25, maxWidth: 30 }] },
        { headerName: "AUG", children: [{ field: "planAug", headerName: "P", filter: false, width: 25, maxWidth: 30 }, { field: "actualsAug", headerName: "A", filter: false, width: 25, maxWidth: 30 }, { field: "daysAug", headerName: "D", filter: false, width: 25, maxWidth: 30 }] },
        { headerName: "SEP", children: [{ field: "planSep", headerName: "P", filter: false, width: 25, maxWidth: 30 }, { field: "actualsSep", headerName: "A", filter: false, width: 25, maxWidth: 30 }, { field: "daysSep", headerName: "D", filter: false, width: 25, maxWidth: 30 }] },
        { headerName: "OCT", children: [{ field: "planOct", headerName: "P", filter: false, width: 25, maxWidth: 30 }, { field: "actualsOct", headerName: "A", filter: false, width: 25, maxWidth: 30 }, { field: "daysOct", headerName: "D", filter: false, width: 25, maxWidth: 30 }] },
        { headerName: "NOV", children: [{ field: "planNov", headerName: "P", filter: false, width: 25, maxWidth: 30 }, { field: "actualsNov", headerName: "A", filter: false, width: 25, maxWidth: 30 }, { field: "daysNov", headerName: "D", filter: false, width: 25, maxWidth: 30 }] },
        { headerName: "DEC", children: [{ field: "planDec", headerName: "P", filter: false, width: 25, maxWidth: 30 }, { field: "actualsDec", headerName: "A", filter: false, width: 25, maxWidth: 30 }, { field: "daysDec", headerName: "D", filter: false, width: 25, maxWidth: 30 }] },
    ]);

    const [columnDefsYtd, setColumnDefsYtd] = useState([
        { field: "partnerName", headerName: "PARTNER NAME", width: 100, filter: false },
        { field: "trainingDaysPlan", headerName: "TRAINING DAYS PLAN", width: 95, maxWidth: 95, filter: false },
        { field: "trainingDaysActuals", headerName: "TRAINING DAYS ACTUALS", width: 95, maxWidth: 95, filter: false },
        { field: "trainingDaysBalance", headerName: "TRAINING DAYS BALANCE", width: 95, maxWidth: 95, filter: false },
        { field: "percentangeOfCompletion", headerName: "% OF COMPLETION", width: 95, maxWidth: 95, filter: false },
        { field: "percentagneBalanceToCompletion", headerName: "% BALANCE TO COMPLETION", width: 95, maxWidth: 95, filter: false },
        { field: "forecastSepToDec", headerName: "FORECAST (SEP-DEC)", width: 95, maxWidth: 95, filter: false },
        { field: "totalForecast", headerName: "TOTAL FORECAST", width: 95, maxWidth: 95, filter: false },
        { field: "percentageDeviation", headerName: "% DEVIATION(FORECAST)", width: 95, maxWidth: 95, filter: false },
        { field: "toBeCompletedBased", headerName: "TO BE COMPLETED BASED ON FORECAST", width: 95, maxWidth: 95, filter: false },
        { field: "percentageToBeCompletedBased", headerName: "% TO BE COMPLETED BASED PLAN", width: 95, maxWidth: 95, filter: false },
    ])

    const gridRef = useRef();
    const [stateData, setStateData] = useState({ filter: '', columnState: '', columnGroupState: '' });
    const gridStateId = useRef();
    const saveGridStateName = 'TrainingSummary';
    //   const autoGroupColumnDef = useMemo(() => {
    //     return {
    //       headerName: 'Order Type',
    //       field: 'orderCategory',
    //       cellRendererParams: {
    //         suppressCount: true,
    //       },
    //       filter: 'agSetColumnFilter',
    //       filterParams: {
    //         treeList: true,
    //       },
    //       minWidth: 280,
    //     };
    //   }, []);

    const autoSizeAll = useCallback(
        (value) => {
            const allColumnIds = [];
            props.gridRef.current.columnApi.getColumns().forEach((column) => {
                allColumnIds.push(column?.getId());
            });
            props.gridRef.current.columnApi.autoSizeColumns(allColumnIds, value);
        },
        [rowData]
    );

    const defaultColDef = useMemo(() => {
        return {
            flex: 1,
            floatingFilter: true,
            sortable: true,
            resizable: true,
            filter: 'agMultiColumnFilter',
            wrapHeaderText: true,
            autoHeaderHeight: true,
        };
    }, []);

    const onGridReady = useCallback((params) => {
        // setRowData(processData(props.rowData));
        autoSizeAll(false);
    }, []);

    const onColumnStateChanged = (params) => {
        stateData.columnState = params?.columnApi?.getColumnState();
        stateData.columnGroupState = params?.columnApi?.getColumnGroupState();
    }

    const gridOptions = {
        SideBarDef: {
            hiddenByDefault: false,
        }
    }


    return (
        <>
            <div style={{ height: 400 }}>
                <AgGridTable
                    rowData={rowData}
                    columnDefs={props.planActualMonthWise === true ? columnDefsMonthWise : props.ytd === true ? columnDefsYtd : columnDefs}
                    defaultColDef={defaultColDef}
                    onGridReady={onGridReady}
                    gridRef={gridRef}
                    // onRowDoubleClicked={onRowDoubleClicked}
                    // onSelectionChanged={onSelectionChanged}
                    hideCheckbox={true}
                    editable={false}
                    pagination={false}
                    showSidebar={false}
                    rowGroupPanelShow={'hide'}
                />
            </div>
        </>
    )
};

export default TerritoryWiseGrid;